import React from 'react';
import { useAuth } from '@/lib/api';
import { LogOut, EyeIcon } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Sticky top banner shown ONLY while a superadmin is impersonating another
 * user. Clicking "Exit" restores the original superadmin session.
 */
const ImpersonationBanner = () => {
    const { user, isImpersonating, stopImpersonating } = useAuth();

    if (!isImpersonating || !user) return null;

    const handleExit = () => {
        stopImpersonating();
        toast.success('Back to your super-admin session');
        window.location.href = '/users';
    };

    return (
        <div
            className="w-full bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white shadow-md"
            data-testid="impersonation-banner"
        >
            <div className="max-w-full mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
                <div className="flex items-center gap-2 min-w-0">
                    <EyeIcon className="h-4 w-4 shrink-0" />
                    <span className="truncate">
                        <span className="font-semibold">Impersonation active:</span>{' '}
                        viewing ERP as{' '}
                        <span className="font-semibold">{user.full_name || user.email}</span>
                        <span className="hidden sm:inline"> ({user.role})</span>
                    </span>
                </div>
                <button
                    onClick={handleExit}
                    className="shrink-0 inline-flex items-center gap-1.5 rounded-md bg-white/20 hover:bg-white/30 px-3 py-1 font-medium transition-colors"
                    data-testid="stop-impersonating-btn"
                >
                    <LogOut className="h-3.5 w-3.5" />
                    Exit impersonation
                </button>
            </div>
        </div>
    );
};

export default ImpersonationBanner;
